import { call, put, select, takeEvery } from 'redux-saga/effects';
import { RequestStatus } from 'constants';
import {
  GET_ACCOUNT_NAMES,
  CREATE_ACCOUNT_NAME,
  UPDATE_ACCOUNT_NAME,
  REMOVE_ACCOUNT_NAME,
  SET_ACTORS_ACCOUNTS_REQ_STATUS,
} from '@control-front-end/common/constants/actorAccounts';
import api from '@control-front-end/common/sagas/api';

/**
 * Получить типы счетов
 */
function* getAccountNames({ callback }) {
  const accounts = yield select((state) => state.accounts);
  const accId = accounts.active;
  // Ставим флаг прогресса загрузки
  yield put({ type: SET_ACTORS_ACCOUNTS_REQ_STATUS, payload: 'inProgress' });
  const { result, data } = yield call(api, {
    method: 'get',
    url: `/account_names/${accId}`,
  });
  // Ставим флаг окончания загрузки
  yield put({ type: SET_ACTORS_ACCOUNTS_REQ_STATUS, payload: 'success' });
  if (result !== RequestStatus.SUCCESS) return;
  yield put({
    type: GET_ACCOUNT_NAMES.SUCCESS,
    payload: data.data,
  });
  if (callback) callback(data.data);
}

/**
 * Создать наименование счета
 */
export function* createAccountName({ payload, callback }) {
  const accounts = yield select((state) => state.accounts);
  const accNames = yield select((state) => state.accountNames);
  const accId = accounts.active;
  const { result, data } = yield call(api, {
    method: 'post',
    url: `/account_names/${accId}`,
    body: { name: payload },
  });
  if (result !== RequestStatus.SUCCESS) return;
  const list = accNames.slice();
  list.unshift({ ...data.data, count: 0 });
  yield put({
    type: CREATE_ACCOUNT_NAME.SUCCESS,
    payload: list,
  });
  if (callback) callback(data.data);
  return data.data;
}

/**
 * Обновить наименование счета
 */
function* updateAccountName({ payload, callback }) {
  const { id, name } = payload;
  const accNames = yield select((state) => state.accountNames);
  const { result, data } = yield call(api, {
    method: 'put',
    url: `/account_names/${id}`,
    body: { name },
  });
  if (result !== RequestStatus.SUCCESS) return;
  const list = structuredClone(accNames);
  const findIndex = list.findIndex((i) => i.id === id);
  const accName = list[findIndex];
  accName.name = name;
  list.splice(findIndex, 1, accName);
  yield put({
    type: UPDATE_ACCOUNT_NAME.SUCCESS,
    payload: list,
  });
  if (callback) callback(data.data);
  return data.data;
}

/**
 * Удалить наименование счета
 */
function* removeAccountName({ payload: id, callback }) {
  const accNames = yield select((state) => state.accountNames);
  const { result } = yield call(api, {
    method: 'delete',
    url: `/account_names/${id}`,
  });
  if (result !== RequestStatus.SUCCESS) return;
  const list = accNames.filter((i) => i.id !== id);
  yield put({
    type: REMOVE_ACCOUNT_NAME.SUCCESS,
    payload: list,
  });
  if (callback) callback();
}

function* accountNames() {
  yield takeEvery(GET_ACCOUNT_NAMES.REQUEST, getAccountNames);
  yield takeEvery(CREATE_ACCOUNT_NAME.REQUEST, createAccountName);
  yield takeEvery(UPDATE_ACCOUNT_NAME.REQUEST, updateAccountName);
  yield takeEvery(REMOVE_ACCOUNT_NAME.REQUEST, removeAccountName);
}

export default accountNames;
